import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError.ts';
import { CarePlanTemplatesApi } from '../../../apis/CarePlanTemplatesApi/CarePlanTemplatesApi.ts';
import {
  ICarePlanTemplate,
  ICarePlanTemplateInput,
} from '../CarePlanTemplate.ts';

interface UpdateVars {
  id: number;
  input: ICarePlanTemplateInput;
}

export function useUpdateCarePlanTemplate() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation<ICarePlanTemplate, AppMedError, UpdateVars>({
    mutationKey: [QueryKeys.carePlanTemplates, 'update'],
    mutationFn: ({ id, input }) => CarePlanTemplatesApi.put(id, input),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.carePlanTemplates],
      });
      notifications.show({
        color: 'teal',
        message: t('carePlan.notifications.updated'),
      });
    },
    onError: (error) => {
      notifications.show({
        color: 'red',
        message: error?.message || t('carePlan.notifications.updateError'),
      });
    },
  });
}
